import React from 'react'
import PropTypes from 'prop-types'
import { Stamp, StampTestAB } from './style'
import { OPPORTUNITIES_INFO } from '../../../utils/constants/opportunities'
import { hasNewCardLayout } from '@/utils/utils'

const dataTestLabel = 'seal_view360'
const {
  'visão360°': { displayName },
} = OPPORTUNITIES_INFO

const Brand360 = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.4 15.0333C2.4 13.8735 4.81766 12.9333 7.8 12.9333V12C3.49218 12 0 13.3581 0 15.0333C0 16.7086 3.49218 18.0667 7.8 18.0667H9.6C10.2627 18.0667 10.8 17.8577 10.8 17.6C10.8 17.3423 10.2627 17.1333 9.6 17.1333H7.8C4.81766 17.1333 2.4 16.1931 2.4 15.0333Z"
        fill="white"
      />
      <path
        d="M24 15.0333C24 13.3581 20.5078 12 16.2 12V12.9333C19.1823 12.9333 21.6 13.8735 21.6 15.0333C21.6 16.0272 19.8247 16.8598 17.4401 17.0777L17.6485 16.9967C18.1172 16.8144 18.1172 16.5189 17.6485 16.3367C17.1799 16.1544 16.4201 16.1544 15.9515 16.3367L13.5515 17.27C13.0828 17.4523 13.0828 17.7477 13.5515 17.93L15.9515 18.8633C16.4201 19.0456 17.1799 19.0456 17.6485 18.8633C18.1172 18.6811 18.1172 18.3856 17.6485 18.2034L17.2297 18.0405C21.0508 17.8445 24 16.5729 24 15.0333Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.05288 7.84962L4.98708 7.89349C4.5976 8.15314 4.36366 8.59027 4.36366 9.05836V15.2455C4.36366 15.6321 4.67706 15.9455 5.06366 15.9455H5.95457C6.34117 15.9455 6.65457 15.6321 6.65457 15.2455V14.4182H17.3455V15.2455C17.3455 15.6321 17.6589 15.9455 18.0455 15.9455H18.9364C19.323 15.9455 19.6364 15.6321 19.6364 15.2455V9.05836C19.6364 8.59027 19.4025 8.15314 19.013 7.89349L18.9472 7.84962C19.2255 7.68888 19.4775 7.53098 19.5265 7.46062C19.6446 7.29092 19.6989 6.78183 19.5265 6.78183H18.1091L17.1623 4.88813C16.8066 4.17668 16.0794 3.72728 15.284 3.72728H8.71608C7.92066 3.72728 7.1935 4.17668 6.83778 4.88813L5.89092 6.78185V6.78183H4.47352C4.30113 6.78183 4.3554 7.29092 4.47352 7.46062C4.5225 7.53098 4.77457 7.68888 5.05288 7.84962ZM7.53199 5.23208L6.16542 7.79439C6.04108 8.02752 6.21002 8.30909 6.47425 8.30909H12H17.5258C17.79 8.30909 17.9589 8.02752 17.8346 7.79439L16.468 5.23208C16.2247 4.77587 15.7498 4.49091 15.2327 4.49091H8.76728C8.25024 4.49091 7.7753 4.77587 7.53199 5.23208ZM5.12729 10.7195V9.68208C5.12729 9.41196 5.42032 9.24365 5.65365 9.37976L8.37266 10.9658C8.69475 11.1537 8.53884 11.6479 8.16724 11.617L5.76916 11.4171C5.40636 11.3869 5.12729 11.0836 5.12729 10.7195ZM18.8727 9.68208V10.7195C18.8727 11.0836 18.5937 11.3869 18.2309 11.4171L15.8328 11.617C15.4612 11.6479 15.3053 11.1537 15.6274 10.9658L18.3464 9.37976C18.5797 9.24365 18.8727 9.41196 18.8727 9.68208Z"
        fill="white"
      />
    </svg>
  )
}

const StampView360 = ({ daInfo, ...rest }) => {
  const hasTestABCard = hasNewCardLayout()

  return !hasTestABCard ? (
    <Stamp daInfo={daInfo} data-test-component={dataTestLabel} {...rest}>
      {displayName}
    </Stamp>
  ) : (
    <StampTestAB daInfo={daInfo} data-test-component={dataTestLabel} {...rest}>
      <Brand360 />
      <span>360º</span>
    </StampTestAB>
  )
}

StampView360.defaultProps = {
  daInfo: false,
}
StampView360.propTypes = {
  daInfo: PropTypes.bool,
}

export default StampView360
